import { objectService } from '@/modules/common/api';
import { apiClient } from '../../../provider';
import { prepareObject } from '../../../provider/utils';
import landmarkScheme from './landmark.graphql';

export default {
  ...objectService,
  fetchLandmarkSchemaId() {
    return apiClient
      .query({
        query: landmarkScheme.fetchLandmarkSchemaId
      })
      .then(r => r.data.schemata[0]?.id || '');
  },
  async fetch(id) {
    const res = await apiClient.query({
      query: landmarkScheme.fetch,
      variables: {
        id
      },
      fetchPolicy: 'no-cache'
    });
    return prepareObject(res.data.object);
  },
  create({ name, description, enabled, schemaId }) {
    return apiClient
      .mutate({
        mutation: landmarkScheme.create,
        variables: {
          input: {
            object: {
              name,
              description,
              enabled,
              schemaId
            }
          }
        }
      })
      .then(r => prepareObject(r.data?.createObject?.object));
  },
  update(id, { name, description }) {
    return apiClient.mutate({
      mutation: landmarkScheme.update,
      variables: {
        id,
        name,
        description
      }
    });
  }
};
